import {
  collection,
  doc,
  getCountFromServer,
  getDoc,
  limit,
  onSnapshot,
  orderBy,
  query,
  QueryConstraint,
  startAfter,
  where,
} from "firebase/firestore";
import { db } from "shared/api/firebase";
import { TablePaginatedData, TablePaginationParams } from "shared/types/tables";
import { Message, Role } from "../types";

export const subscribeToTicketMessages = (
  paginationData: TablePaginationParams,
  updateData: (
    data: TablePaginatedData<Message> & {
      ticketAdminUnreadMessagesCount: number;
    },
  ) => void,
  ticketId: string,
) => {
  try {
    const collectionRef = collection(
      db,
      `customerSupportTickets/${ticketId}/messages`,
    );

    const params: QueryConstraint[] = [
      limit(paginationData.limit),
      where("from", "!=", Role.System),
      orderBy("timestamp", "desc"),
    ];

    if (paginationData.endListItem) {
      params.push(startAfter(paginationData.endListItem));
    }

    const q = query(collectionRef, ...params);
    const docRef = doc(db, "customerSupportTickets", ticketId);

    return onSnapshot(q, async (querySnap) => {
      try {
        const ticketSnapshot = await getDoc(docRef);
        const countSnap = await getCountFromServer(q);

        const items = querySnap.docs.map((messageSnap) => {
          const data = messageSnap.data() as Message;
          return {
            ...data,
            id: messageSnap.id,
          };
        });

        const data: TablePaginatedData<Message> & {
          ticketAdminUnreadMessagesCount: number;
        } = {
          items,
          totalCount: countSnap.data().count,
          ticketAdminUnreadMessagesCount:
            ticketSnapshot.data()?.adminUnreadMessagesCount,
          startListItem: querySnap.docs[0],
          endListItem: querySnap.docs[querySnap.size - 1],
        };

        updateData(data);
      } catch (error) {
        console.error("Error fetching messages: ", error);
      }
    });
  } catch (error) {
    console.error("Error setting up snapshot listener: ", error);
    throw new Error("Failed to fetch messages");
  }
};
